import { render, staticRenderFns } from "./ListFornecedores.vue?vue&type=template&id=33918d42&"
import script from "./ListFornecedores.vue?vue&type=script&lang=js&"
export * from "./ListFornecedores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports